import React from 'react';
import {Flex, useTheme} from '@chakra-ui/react';
import Icon from '../../../components/Icon';
import {TextG12} from '../../../components/typography';
import {Partner} from '../../../types/article';
import useAuth from '../../../hooks/useAuth';
import {
  useFetchPotentialPartnerBusinessManagers,
} from "../../../hooks/useUsers";
import PotentialBusinessManagersModal from "../../../components/UsersList/PotentialBusinessManagersModal";
import {assignUserRoleToEntity, removeUserRoleFromEntity} from "../../../endpoints/api";
import {
  EntityRole,
  useGetCurrentUserRoleForEntity,
  useGetUsersAndRolesForEntity
} from "../../../hooks/useEntityUserRole";

const IconsHeader = ({
  partner,
}: {
  partner: Partner;
}) => {
  const theme = useTheme();
  const {user} = useAuth();

  const { data: currentRole } = useGetCurrentUserRoleForEntity('partners', partner.id!);

  const [showBusinessManagersModal, setShowBusinessManagersModal] = React.useState(false);

  return (
    <Flex justify="center" gap=".5rem" whiteSpace="nowrap" flexWrap="wrap">
      {(currentRole?.data === EntityRole.MANAGER) && (
        <>
          <Flex
            minW="60px"
            color={theme.colors.lightBlue}
            direction="column"
            align="center"
            onClick={() => setShowBusinessManagersModal(true)}>
            <Icon iconName="fi-rr-user-pen" style={{fontSize: '1.5rem'}} />
            <TextG12>Team</TextG12>
          </Flex>
          <PotentialBusinessManagersModal
            isOpen={showBusinessManagersModal}
            onClose={() => setShowBusinessManagersModal(false)}
            title="Users Management"
            assignUserRoleToEntity={(entityId: number, userId: number, roleId: number) => assignUserRoleToEntity('partners', entityId, userId, roleId)}
            removeUserRoleFromEntity={(entityId: number, userId: number) => removeUserRoleFromEntity('partners', entityId, userId)}
            fetchUsersAndRoles={(entityId: number) => useGetUsersAndRolesForEntity('partners', entityId)}
            fetchUsersHook={useFetchPotentialPartnerBusinessManagers}
            entityId={partner.id}
          />
        </>
      )}
    </Flex>
  );
};

export default IconsHeader;
